import styled from '@emotion/styled';
import { DoubleArrowUpIcon } from 'src/assets/icons/DoubleArrowUpIcon';

export const IdContainer = styled('div', { label: 'IdContainer' })`
    cursor: text;
    user-select: text;
    display: inline;
`;

export const HeaderWrapper = styled('h4', { label: 'HeaderWrapper' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SelectionWrapper = styled('div', { label: 'SelectionWrapper' })`
    display: flex;
    flex-direction: column;
`;

export const SelectionIdTitle = styled('div', { label: 'SelectionIdTitle' })`
    font-size: 11px;
    text-decoration: underline;
`;

interface StyledInputPropsType {
    isDisabled?: boolean;
}

//Important coz old css files.
export const StyledInput = styled('input', { label: 'StyledInput' })<StyledInputPropsType>`
    cursor: ${({ isDisabled }): string => isDisabled === true ? 'text' : 'auto'};
    opacity: ${({ isDisabled }): string => isDisabled === true ? '0.4 !important' : '1'};
    padding-top: 10px !important;
`;

export const PriceInputWrapper = styled('div', { label: 'PriceInputWrapper' })`
    position: relative;
`;

export const PriceBoostIconWrapper = styled(DoubleArrowUpIcon, { label: 'PriceBoostIconWrapper' })`
    inset: 0 12px 0 auto;
    margin: auto 0;
    position: absolute;
`;
